import React, { useEffect, useState } from 'react'
import { Row, Card, Form, Input, Space, Button, Col, Radio, Typography } from 'antd'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'
import { sendEmailForExpressPolicyChanges } from '../services'
import { DRIVER_JSON_MAP } from './RemoveHouseholdMemberConstants'

import RemoveHHMStyle from '../../styles/RemoveHouseholdMember.module.css'
import { NoIndex } from './NoIndex'

const { Text } = Typography

const RemoveHouseholdMember = () => {
  useEffect(() => {
    window.location.href = "/404";
  }, []);

  return null;

  const [driver, setDriver] = useState({
    firstName: '',
    lastName: '',
    policyNumber: '',
    phoneNumber: '',
    streetAddress: '',
    emailAddress: '',
    zipCode: '',
    removeHousehold: {
      firstName: '',
      lastName: '',
      isMovingToNewAddress: '',
      vehicleAccess: '',
      newAddress: {
        streetAddress: '',
        apt: '',
        city: '',
        state: '',
        zipCode: ''
      }
    },
    effectDate: ''
  })
  const [disableButton, setDisableButton] = useState(false)

  const validateBasicFormData = driverInfo => {
    const {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      emailAddress,
      zipCode,
      removeHousehold: {
        firstName: fName,
        lastName: lName,
        isMovingToNewAddress,
        vehicleAccess,
        newAddress: { streetAddress: newStreetAddress, city: newCity, state: newState, zipCode: newZipCode }
      },
      effectDate
    } = driverInfo

    if (
      firstName &&
      lastName &&
      policyNumber &&
      phoneNumber &&
      streetAddress &&
      zipCode &&
      emailAddress &&
      fName &&
      lName &&
      isMovingToNewAddress &&
      vehicleAccess &&
      effectDate
    ) {
      if (isMovingToNewAddress === 'Yes') {
        if (newStreetAddress && newCity && newState && newZipCode) {
          return { isValid: true }
        } else {
          return { isValid: false }
        }
      } else {
        return { isValid: true }
      }
    } else {
      return { isValid: false }
    }
  }

  const validateDate = driverInfo => {
    const { effectDate } = driverInfo

    if (new Date(effectDate).toString() === 'Invalid Date') {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateEmail = driverInfo => {
    const { emailAddress } = driverInfo
    const regEx = /\S+@\S+\.\S+/

    if (emailAddress.length > 0 && regEx.test(emailAddress)) {
      return { isValid: true }
    } else {
      return { isValid: false }
    }
  }

  const validateZipCode = driverInfo => {
    const { zipCode } = driverInfo

    if (zipCode.length < 5) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const formatPhoneNumber = phoneNumber => {
    const USNumber = phoneNumber.match(/(\d{3})(\d{3})(\d{4})/)
    return USNumber ? `(${USNumber?.[1]}) ${USNumber?.[2]}-${USNumber?.[3]}` : ''
  }

  const validatePhoneNumber = driverInfo => {
    const { phoneNumber } = driverInfo
    const updatedNumber = phoneNumber.replace(/[^\w\s]/gi, '').replace(' ', '')
    if (formatPhoneNumber(updatedNumber).length < 10) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateFields = driverInfo => {
    let validationResponse = true
    const initialResponse = validateBasicFormData(driverInfo)
    if (initialResponse.isValid) {
      const dateValidationResponse = validateDate(driverInfo)
      const emailValidationResponse = validateEmail(driverInfo)
      const zipCodeValidationResponse = validateZipCode(driverInfo)
      const phoneValidationResponse = validatePhoneNumber(driverInfo)
      if (
        dateValidationResponse.isValid &&
        emailValidationResponse.isValid &&
        zipCodeValidationResponse.isValid &&
        phoneValidationResponse.isValid
      ) {
        validationResponse = true
      } else {
        validationResponse = false
      }
    } else {
      validationResponse = false
    }
    return validationResponse
  }

  const stripFinalJson = driverInfo => {
    const {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      emailAddress,
      zipCode,
      removeHousehold: {
        firstName: removeHouseholdFirstName,
        lastName: removeHouseholdLastName,
        isMovingToNewAddress,
        vehicleAccess,
        newAddress: { streetAddress: newStAddress, zipCode: newZipCode, apt, city, state }
      },
      effectDate
    } = driverInfo

    const obj = {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      zipCode,
      emailAddress,
      removeHousehold: {
        firstName: removeHouseholdFirstName,
        lastName: removeHouseholdLastName,
        isMovingToNewAddress,
        ...(isMovingToNewAddress === 'Yes' && {
          newAddress: {
            streetAddress: newStAddress,
            apt,
            city,
            state,
            zipCode: newZipCode
          }
        }),
        vehicleAccess
      },
      effectDate
    }
    return obj
  }

  const buildTable = driverInfo => {
    var table = '<table border="1">'
    table += '<tr><td colspan="2"><b>Policyholder Information</b></td></tr>'
    for (const key in driverInfo) {
      if (driverInfo[key] instanceof Object) {
        table += '<tr><td colspan="2"><b>Remove Member Information</b></td></tr>'
        for (const additionalKey in driverInfo[key]) {
          if (driverInfo[key][additionalKey] instanceof Object) {
            table += '<tr><td colspan="2"><b>Household member new address</b></td></tr>'
            for (const addressKey in driverInfo[key][additionalKey]) {
              table += `<tr><td>${DRIVER_JSON_MAP[key][additionalKey][addressKey]}</td><td>${driverInfo[key][additionalKey][addressKey]}</td></tr>`
            }
          } else {
            table += `<tr><td>${DRIVER_JSON_MAP[key][additionalKey]}</td><td>${driverInfo[key][additionalKey]}</td></tr>`
          }
        }
      } else {
        table += `<tr><td>${DRIVER_JSON_MAP[key]}</td><td>${driverInfo[key]}</td></tr>`
      }
    }
    table += '</table>'
    return table
  }

  const handleSubmit = async () => {
    setDisableButton(true)
    const finalJson = stripFinalJson(driver)
    const htmlText = buildTable(finalJson)
    const mailObj = {
      subject: `[Remove Household Member Information] - ${driver.policyNumber}`,
      content: htmlText
    }
    localStorage.setItem('expressPolicyChangeType', 'Remove Household Member')

    await sendEmailForExpressPolicyChanges(mailObj)

    const newWindow = window.open('/g/express-policy-changes/result', '_self', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const updateUserTextFields = (text, field) => {
    const clonedUser = { ...driver }
    clonedUser[field] = text
    setDriver(clonedUser)
  }

  const buttonStatus = !validateFields(driver) || disableButton
  return (
    <div className="container">
      <NoIndex/>
      <GlobalHeader />
      <>
        <EmptyHeaderHero minHeight={true} title="Remove Household Member" />
        <div className={`${RemoveHHMStyle["remove-household"]}`}>
          <p className={`${RemoveHHMStyle["disclaimer"]}`}>Once your change request has been approved and processed, you will be sent updated policy documents and billing schedule.</p>
          <Row>
            <Card className={`${RemoveHHMStyle["register-card"]}`}>
              <h5 className={`${RemoveHHMStyle["sub-label"]}`}>Policyholder Information</h5>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveHHMStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "firstName") }}
                      placeholder="First Name*"
                      value={driver.firstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveHHMStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "lastName") }}
                      placeholder="Last Name*"
                      value={driver.lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveHHMStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "policyNumber") }}
                      placeholder="Policy Number*"
                      value={driver.policyNumber}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${RemoveHHMStyle["input-text"]} ${RemoveHHMStyle["phone-number"]}`}
                      mask="(999) 999-9999"
                      onChange={event => { updateUserTextFields(event.target.value, "phoneNumber") }}
                      placeholder="Phone Number*"
                      value={driver.phoneNumber}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveHHMStyle["input-text"]}`}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          streetAddress: event.target.value
                        })
                      }}
                      placeholder="Street Address*"
                      value={driver.streetAddress}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveHHMStyle["input-text"]}`}
                      maxLength={5}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          zipCode: event.target.value.replace(/\D/g, '')
                        })
                      }}
                      placeholder="Zip Code*"
                      value={driver.zipCode}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveHHMStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "emailAddress") }}
                      placeholder="Email Address*"
                      value={driver.emailAddress}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <h5 className={`${RemoveHHMStyle["sub-label"]}`}>Remove Household Member Information</h5>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveHHMStyle["input-text"]}`}
                      onChange={event => {
                        const removeHousehold = {
                          ...driver.removeHousehold,
                          firstName: event.target.value
                        }
                        setDriver({
                          ...driver,
                          removeHousehold
                        })
                      }}
                      placeholder="First Name*"
                      value={driver.removeHousehold.firstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveHHMStyle["input-text"]}`}
                      onChange={event => {
                        const removeHousehold = {
                          ...driver.removeHousehold,
                          lastName: event.target.value
                        }
                        setDriver({
                          ...driver,
                          removeHousehold
                        })
                      }}
                      placeholder="Last Name*"
                      value={driver.removeHousehold.lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Text className={`${RemoveHHMStyle["form-label"]}`}>Is the household member moving to a new address?*</Text>
              <Row>
                <Col xl={{ span: 14 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <Radio.Group
                      onChange={event => {
                        const removeHousehold = {
                          ...driver.removeHousehold,
                          isMovingToNewAddress: event.target.value
                        }
                        setDriver({
                          ...driver,
                          removeHousehold
                        })
                      }}
                      value={driver.removeHousehold.isMovingToNewAddress}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              {driver.removeHousehold.isMovingToNewAddress === 'Yes' && (
                <>
                  <Row>
                    <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                      <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${RemoveHHMStyle["input-text"]}`}
                          onChange={event => {
                            const newAddress = {
                              ...driver.removeHousehold.newAddress
                            }
                            const removeHousehold = {
                              ...driver.removeHousehold,
                              newAddress: {
                                ...newAddress,
                                streetAddress: event.target.value
                              }
                            }
                            setDriver({
                              ...driver,
                              removeHousehold
                            })
                          }}
                          placeholder="Street Address"
                          value={driver.removeHousehold.newAddress.streetAddress}
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                      <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${RemoveHHMStyle["input-text"]}`}
                          onChange={event => {
                            const newAddress = {
                              ...driver.removeHousehold.newAddress
                            }
                            const removeHousehold = {
                              ...driver.removeHousehold,
                              newAddress: {
                                ...newAddress,
                                apt: event.target.value
                              }
                            }
                            setDriver({
                              ...driver,
                              removeHousehold
                            })
                          }}
                          placeholder="Apartment#"
                          value={driver.removeHousehold.newAddress.apt}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                      <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${RemoveHHMStyle["input-text"]}`}
                          onChange={event => {
                            const newAddress = {
                              ...driver.removeHousehold.newAddress
                            }
                            const removeHousehold = {
                              ...driver.removeHousehold,
                              newAddress: {
                                ...newAddress,
                                city: event.target.value
                              }
                            }
                            setDriver({
                              ...driver,
                              removeHousehold
                            })
                          }}
                          placeholder="City"
                          value={driver.removeHousehold.newAddress.city}
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                      <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${RemoveHHMStyle["input-text"]}`}
                          onChange={event => {
                            const newAddress = {
                              ...driver.removeHousehold.newAddress
                            }
                            const removeHousehold = {
                              ...driver.removeHousehold,
                              newAddress: {
                                ...newAddress,
                                state: event.target.value
                              }
                            }
                            setDriver({
                              ...driver,
                              removeHousehold
                            })
                          }}
                          placeholder="State"
                          value={driver.removeHousehold.newAddress.state}
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                      <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${RemoveHHMStyle["input-text"]}`}
                          onChange={event => {
                            const newAddress = {
                              ...driver.removeHousehold.newAddress
                            }
                            const removeHousehold = {
                              ...driver.removeHousehold,
                              newAddress: {
                                ...newAddress,
                                zipCode: event.target.value
                              }
                            }
                            setDriver({
                              ...driver,
                              removeHousehold
                            })
                          }}
                          placeholder="Zip Code"
                          value={driver.removeHousehold.newAddress.zipCode}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
              <Text className={`${RemoveHHMStyle["form-label"]}`}>
                Will the household member have access to, or take a vehicle that is currently insured on the policy?*
              </Text>
              <Row>
                <Col xl={{ span: 14 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <Radio.Group
                      onChange={event => {
                        const removeHousehold = {
                          ...driver.removeHousehold,
                          vehicleAccess: event.target.value
                        }
                        setDriver({
                          ...driver,
                          removeHousehold
                        })
                      }}
                      value={driver.removeHousehold.vehicleAccess}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Text className={`${RemoveHHMStyle["form-effect-label"]}`}>When would you like this change to go into effect?*</Text>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveHHMStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${RemoveHHMStyle["dob"]}`}
                      mask="99/99/9999"
                      onChange={event => {
                        setDriver({
                          ...driver,
                          effectDate: event.target.value
                        })
                      }}
                      placeholder="mm/dd/yyyy*"
                      value={driver.effectDate}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Row>
          <Row className={`${RemoveHHMStyle["submit-container"]}`}>
            <Form.Item className={`${RemoveHHMStyle["btn-control"]} ${RemoveHHMStyle["button-submit-form"]}`}>
              <Space>
                <Button className={`${RemoveHHMStyle["register"]} ${RemoveHHMStyle["register-form-button"]}`} disabled={buttonStatus} onClick={handleSubmit}>
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Row>
        </div>
      </>
      <GlobalFooter />
    </div>
  )
}

RemoveHouseholdMember.propTypes = {}

export default RemoveHouseholdMember
